import { createStyles } from '@mantine/core';
import type { ActivityLogOut, PolicyViolationOut } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { formatMonthAndDay } from '../../../../../utils/time';

const useStyles = createStyles(() => ({
	group: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'flex-start',
	},
	text: {
		flex: 1,
	},
}));

export function IssueActivityLog({
	policyResult,
	activityLog,
}: {
	policyResult: PolicyViolationOut;
	activityLog?: ActivityLogOut;
}) {
	const { classes } = useStyles();
	let label: string | null = null;
	if (!activityLog) {
		label = `Issue started · ${formatMonthAndDay(policyResult.created_at)}`;
	} else {
		label = `${activityLog.event_blocks.map((block) => block.value).join(' ')} by ${' '}
				${activityLog.performer_metadata?.display_name} · ${' '}
				${formatMonthAndDay(activityLog.logged_at)}`;
	}

	return (
		<Text className={classes.text} size="sm" color="text/secondary/default">
			{label}
		</Text>
	);
}
